import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  leadershipData: [],
  totalleadership: 0,
  isOpenModal: false,
  isImageOpenModal: false,
  isPartnerOpenModal: false,
  isStatusOpenModal: false,
}

export const leadershipSlice = createSlice({
  name: "leadership",
  initialState,
  reducers: {
    setleadershipData(state, { payload }) {
      state.leadershipData = payload.result
      state.totalleadership = payload.count
    },
    updateleadershipData(state, { payload }) {
      const objIndex = state.leadershipData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.leadershipData[objIndex] = payload
      }
    },
    pushleadershipData(state, { payload }) {
      state.leadershipData.push(payload)
      state.totalleadership = + 1
    },
    sliceTestData(state, { payload }) {
      const objIndex = state.leadershipData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.leadershipData.splice(objIndex, 1)
        state.totalleadership -= 1
      }
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isImageOpenModal(state, { payload }) {
      state.isImageOpenModal = payload
    },
    ImagestatusToggle(state, { payload }) {
      state.isImageOpenModal = !state.isImageOpenModal
    },
    isPartnerOpenModal(state, { payload }) {
      state.isPartnerOpenModal = payload
    },
    PartnerstatusToggle(state, { payload }) {
      state.isPartnerOpenModal = !state.isPartnerOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    },
  }
})

export const { setleadershipData, updateleadershipData, pushleadershipData, sliceTestData, isOpenModal, ModalToggle, isImageOpenModal, ImagestatusToggle, isPartnerOpenModal, PartnerstatusToggle, isOpenStatusModal, statusToggle } = leadershipSlice.actions;

export default leadershipSlice.reducer;

export function getleadership(status) {
  return async function getleadershipThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getLeadership(status).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setleadershipData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addleadership(payload) {
  return async function addleadershipThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addLeadership(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushleadershipData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateleadership(id, data) {
  return async function updateleadershipThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateLeadership(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateleadershipData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateleadershipImage(id, image) {
  return async function updateleadershipImageThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateLeadershipImage(id, image).then(
        (response) => {
          dispatch(ImagestatusToggle())
          dispatch(setLoading(false))
          dispatch(updateleadershipData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateIconImage(id, image) {
  return async function updatepartnerImageThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateLeadershipIcon(id, image).then(
        (response) => {
          dispatch(PartnerstatusToggle())
          dispatch(setLoading(false))
          dispatch(updateleadershipData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function updateLeadershipStatus(id, status) {
  return async function updateStatusThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateLeadershipStatus(id, status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(setLoading(false))
          dispatch(updateleadershipData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function deleteleadership(id) {
  return async function deleteleadershipImageThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteLeadership(id).then(
        (response) => {
          dispatch(sliceTestData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

